import { render, staticRenderFns } from "./add-competencies.vue?vue&type=template&id=2975b065&"
import script from "./add-competencies.vue?vue&type=script&lang=js&"
export * from "./add-competencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports